// Import libraries
import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../../components/header/Header';
// Import custom modules

const Layout: React.FC = () => {
  return (
    <main id="app" className="min-h-[500px] w-full">
      <Header />
      <Outlet />
    </main>
  );
};

export default Layout;
